import { render, staticRenderFns } from "./GoogleDataStudio.vue?vue&type=template&id=7790bd37&scoped=true&"
import script from "./GoogleDataStudio.vue?vue&type=script&lang=js&"
export * from "./GoogleDataStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790bd37",
  null
  
)

export default component.exports